export default "__VITE_ASSET__2ad09759__"